export const ChildrenEducationDeductionOption = [
  {
    value: 0,
    text: window.$xinI18n('不符合，扣除0元', 'Home-shortcut-bufuhekou0yuan')
  },
  {
    value: 1000,
    text: window.$xinI18n('一个孩子，夫妻各扣除1000元', 'Home-shortcut-yigehaizikouchu500')
  },
  {
    value: 2000,
    text: window.$xinI18n('一个孩子，仅有一方扣除2000元', 'Home-shortcut-yigehaiziyifangkouchu500')
  },
  {
    value: '2000',
    text: window.$xinI18n('两个孩子，夫妻各扣除2000元', 'Home-shortcut-lianggehaizigekouchu1000yuan')
  },
  {
    value: 4000,
    text: window.$xinI18n('两个孩子，仅有一方扣除4000元', 'Home-shortcut-lianggehaiziyifangkouchu2000yuan')
  }
];

export const ContinuingEducationDeductionOption = [
  {
    value: 0,
    text: window.$xinI18n('不符合，扣除0元', 'Home-shortcut-bufuhekou0yuan')
  },
  {
    value: 400,
    text: window.$xinI18n('接受学历教育中，扣除400', 'Home-shortcut-jieshoujiaoyuzhongkouchu400')
  }
];

export const SupportElderlyDeductionTypeOption = [
  {
    value: 0,
    text: window.$xinI18n('指定分摊', 'Home-shortcut-zhidingfentan')
  },
  {
    value: 1,
    text: window.$xinI18n('约定分摊', 'Home-shortcut-yuedingfentan')
  }
];

export const SupportElderlyDeductionOption = [
  {
    value: 0,
    text: window.$xinI18n('不符合，扣除0元', 'Home-shortcut-bufuhekou0yuan')
  },
  {
    value: 3000,
    text: window.$xinI18n('独生子女，扣除3000元', 'Hom-shortcut-dushengzinvkou2000')
  },
  {
    value: 1500,
    text: window.$xinI18n('两', 'Home-shortcut-liang') + window.$xinI18n('兄妹姐弟分摊，扣除{#1}元', 'Home-shortcut-xiongdifentanxxyuan', [1500])
  },
  {
    value: 1000,
    text: window.$xinI18n('三', 'Home-shortcut-san') + window.$xinI18n('兄妹姐弟分摊，扣除{#1}元', 'Home-shortcut-xiongdifentanxxyuan', [1000])
  },
  {
    value: 750,
    text: window.$xinI18n('四', 'Home-shortcut-si') + window.$xinI18n('兄妹姐弟分摊，扣除{#1}元', 'Home-shortcut-xiongdifentanxxyuan', [750])
  },
  {
    value: 600,
    text: window.$xinI18n('五', 'Home-shortcut-wu') + window.$xinI18n('兄妹姐弟分摊，扣除{#1}元', 'Home-shortcut-xiongdifentanxxyuan', [600])
  },
  {
    value: 500,
    text: window.$xinI18n('六', 'Home-shortcut-liu') + window.$xinI18n('兄妹姐弟分摊，扣除{#1}元', 'Home-shortcut-xiongdifentanxxyuan', [500])
  },
  {
    value: 428.6,
    text: window.$xinI18n('七', 'Home-shortcut-qi') + window.$xinI18n('兄妹姐弟分摊，扣除{#1}元', 'Home-shortcut-xiongdifentanxxyuan', [428.6])
  },
  {
    value: 375,
    text: window.$xinI18n('八', 'Home-shortcut-ba') + window.$xinI18n('兄妹姐弟分摊，扣除{#1}元', 'Home-shortcut-xiongdifentanxxyuan', [375])
  },
  {
    value: 333.3,
    text: window.$xinI18n('九', 'Home-shortcut-jiu') + window.$xinI18n('兄妹姐弟分摊，扣除{#1}元', 'Home-shortcut-xiongdifentanxxyuan', [333.3])
  },
  {
    value: 300,
    text: window.$xinI18n('十', 'Home-shortcut-shi') + window.$xinI18n('兄妹姐弟分摊，扣除{#1}元', 'Home-shortcut-xiongdifentanxxyuan', [300])
  }
];

export const HousingLoanDeductionOption = [
  {
    value: 0,
    text: window.$xinI18n('不符合，扣除0元', 'Home-shortcut-bufuhekou0yuan')
  },
  {
    value: 500,
    text: window.$xinI18n('夫妻各扣除500元', 'Home-shortcut-fuqige500yuan')
  },
  {
    value: 1000,
    text: window.$xinI18n('仅由一方扣除1000元', 'Home-shortcut-yifangkouchu1000yuan')
  }
];

export const HousingRentDeductionOption = [
  {
    value: 0,
    text: window.$xinI18n('不符合，扣除0元', 'Home-shortcut-bufuhekou0yuan')
  },
  {
    value: 1500,
    text: window.$xinI18n('直辖市、省会城市、计划单列市等，扣除1500元', 'Home-shortcut-shenghuichengshikouchu1500yuan')
  },
  {
    value: 1100,
    text: window.$xinI18n('所在城市户籍人口超过100万，扣除1100元', 'Home-shortcut-chaoguo100wankouchu1100yuan')
  },
  {
    value: 800,
    text: window.$xinI18n('所在城市户籍人口少于100万，扣除800元', 'Home-shortcut-shaoyu100wankouchu800yuan')
  }
];

export const ChildReduceDeductionOption = [
  {
    value: 0,
    text: window.$xinI18n('不符合，扣除0元', 'Home-shortcut-bufuhekou0yuan')
  },
  {
    value: 2000,
    text: window.$xinI18n('仅由一方扣除2000元', 'Home-shortcut-yifangkouchu1000yuan')
  },
  {
    value: 1000,
    text: window.$xinI18n('夫妻各扣除1000元', 'Home-shortcut-fuqige500yuan')
  }
];
